package br.com.texeratx.boardgametimeapp.ui.screens.expansions.edit

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowBack
import androidx.compose.material.icons.filled.Save
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import br.com.texeratx.boardgametimeapp.core.i18n.LocalStrings
import br.com.texeratx.boardgametimeapp.ui.components.designsystem.AppScreenScaffold
import br.com.texeratx.boardgametimeapp.ui.components.designsystem.AppTopBarColors

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun EditExpansionUI(
    state: EditExpansionState,
    snackbarHost: @Composable () -> Unit,
    onBack: () -> Unit,
    onNameChange: (String) -> Unit,
    onImageUrlChange: (String) -> Unit,
    onBggUrlChange: (String) -> Unit,
    onGameSelected: (Long) -> Unit,
    onSave: () -> Unit,
    onDismissError: () -> Unit
) {
    val S = LocalStrings.current
    var gamesMenuExpanded by remember { mutableStateOf(false) }

    if (state.errorMessage != null) {
        AlertDialog(
            onDismissRequest = onDismissError,
            confirmButton = { Button(onClick = onDismissError) { Text(S.ok) } },
            title = { Text(S.oops) },
            text = { Text(state.errorMessage ?: "") }
        )
    }

    AppScreenScaffold(
        snackbarHost = snackbarHost,
        topBar = {
            TopAppBar(
                title = { Text(S.editExpansionTitle) },
                navigationIcon = {
                    IconButton(onClick = onBack) {
                        Icon(Icons.Default.ArrowBack, contentDescription = S.back)
                    }
                },
                actions = {
                    IconButton(
                        onClick = onSave,
                        enabled = !state.isSaving && !state.isLoading
                    ) {
                        Icon(Icons.Default.Save, contentDescription = S.save)
                    }
                },
                colors = AppTopBarColors()
            )
        }
    ) { padding ->
        Column(
            modifier = Modifier
                .padding(padding)
                .padding(16.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp)
        ) {

            if (state.isLoading) {
                CircularProgressIndicator()
                return@Column
            }

            val selectedGameName = state.games.firstOrNull { it.id == state.selectedGameId }?.name
                ?: (state.selectedGameId?.toString() ?: S.selectGame)

            Column {
                OutlinedTextField(
                    value = selectedGameName,
                    onValueChange = {},
                    readOnly = true,
                    label = { Text(S.labelGame) },
                    modifier = Modifier
                        .fillMaxWidth()
                        .clickable { gamesMenuExpanded = true }
                )

                DropdownMenu(
                    expanded = gamesMenuExpanded,
                    onDismissRequest = { gamesMenuExpanded = false }
                ) {
                    state.games.forEach { g ->
                        DropdownMenuItem(
                            text = { Text(g.name) },
                            onClick = {
                                onGameSelected(g.id)
                                gamesMenuExpanded = false
                            }
                        )
                    }
                }
            }

            OutlinedTextField(
                value = state.name,
                onValueChange = onNameChange,
                label = { Text(S.labelExpansionName) },
                modifier = Modifier.fillMaxWidth()
            )

            OutlinedTextField(
                value = state.imageUrl,
                onValueChange = onImageUrlChange,
                label = { Text(S.labelImageUrlOptional) },
                modifier = Modifier.fillMaxWidth()
            )

            OutlinedTextField(
                value = state.bggUrl,
                onValueChange = onBggUrlChange,
                label = { Text(S.labelBggUrlOptional) },
                modifier = Modifier.fillMaxWidth()
            )

            Spacer(Modifier.height(8.dp))

            Button(
                onClick = onSave,
                enabled = !state.isSaving,
                modifier = Modifier.fillMaxWidth(),
                shape = RoundedCornerShape(16.dp)
            ) {
                if (state.isSaving) {
                    CircularProgressIndicator()
                } else {
                    Text(S.saveChanges)
                }
            }
        }
    }
}
